import { theme } from '@theme';
import styled from 'styled-components';

export const DealTypeSticker = styled.span.attrs<{
  additionalClassName?: string;
}>((props) => ({
  className: `${props.additionalClassName}`,
}))<{ additionalClassName?: string }>`
  background: ${theme.palette.text.purple};
  color: ${theme.palette.white};
  display: inline-block;
  border-radius: 50%;
  font-size: ${theme.typography.fontSize14}px;
  font-weight: ${theme.typography.fontWeights.bold};
  height: 19px;
  width: 19px;
  margin: 0 auto;
  text-align: center;
  padding-top: 1px;
  line-height: 1.3;

  &.Lease {
    background-color: ${theme.palette.leaseColor};
  }
  &.Finance {
    background-color: ${theme.palette.yellow};
  }
  &.Cash {
    background-color: ${theme.palette.green};
  }
  &.Service {
    background-color: ${theme.palette.sidebarGradient.from};
  }
  &.NewCust {
    background-color: ${theme.palette.darkCyan};
  }
  &.None {
    background-color: ${theme.palette.transparent};
  }
`;
